<script lang="ts">
	import { DefaultNav } from "@hitit/new_ui/src";
	import { onMount } from "svelte";
	export let useTerm = true;

	let termURL = "HITIT_HUBINFO_URL" + "privacy";

</script>

<div class="container">
	<!-- form slot-->
	<div class="box">
		<slot />
	</div>
	<a id="term" href={termURL} class:hidden={!useTerm}>
		<DefaultNav -term>
			회원가입 시 개인정보 처리방침과 이용약관을 확인하였으며, 동의합니다.
		</DefaultNav>
	</a>
</div>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 100vh;

		position: relative;

		.box {
			display: flex;
			width: 100%;
			box-sizing: border-box;
			padding: 20px;
			flex-grow: 1;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		#term {
			display: inline;
			margin-bottom: 50px;
			text-align: center;
			text-decoration: none;
			color: var(--default-nav);
			font-size: 12px;
			&:visited {
				color: var(--default-nav);
			}

			&.hidden {
				display: none;
			}
			:global(.-term) {
				font-size: 0.75rem;
			}
		}
	}

</style>
